<template>
    <div id="app">
        <v-container fluid class="bg px-3 py-4" v-scroll="onScroll">
            <v-fab-transition>
                <v-btn fixed bottom right fab v-show="!hidden" @click="$vuetify.goTo(0)">
                    <img src="./images/btn_back_to_top.png" alt="btt" :style="{ width: '100%' }">
                </v-btn>
            </v-fab-transition>
            <!-- <div :style="{ position: 'absolute', top: '4vh', right: '16px'}">
                <v-menu offset-y transition="slide-y-transition" attach="#langbtn" light bottom>
                <v-btn flat small slot="activator" >{{ currentLang }}</v-btn>
                <v-list>
                    <v-list-tile v-for="lang in language" :key="lang.value" @click="changeLanguage(lang.value)">
                        <v-list-tile-title>{{ lang.title }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
                </v-menu>
            </div> -->
            <v-layout row justify-center>
                <Content v-bind:lang="currentLang"/>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    language: [
      { title: '简体中文', value: 'CN' },
      { title: '繁体中文', value: 'TW' },
      { title: 'English', value: 'EN' },
      { title: '日本語', value: 'JP' },
      { title: '한국어', value: 'KR' },
      { title: 'Français', value: 'FR' },
      { title: 'Español', value: 'ES' },
      { title: 'Deutsch', value: 'DE' }
    ],
    offsetTop: 0,
    hidden: true
  }),
  computed: {
    currentLang() {
      const lang = this.language.find(item => item.value === this.$i18n.locale);
      return lang.title;
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    backTop() {
      this.offsetTop = 0;
    },
    onScroll() {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.offsetTop > 400) {
        this.hidden = false;
      } else {
        this.hidden = true;
      }
    }
  }
};
</script>

<style>
@font-face {
  font-family: 'Gotham-Medium';
  src: url('../static/fonts/gotham-medium.eot'),
    url('../static/fonts/gotham-medium.woff') format('woff'),
    url('../static/fonts/gotham-medium.ttf') format('truetype'),
    url('../static/fonts/gotham-medium.svg') format('svg');
  /* Legacy iOS */
}

@font-face {
  font-family: 'Gotham-Book';
  src: url('../static/fonts/gotham-book.eot'),
    url('../static/fonts/gotham-book.woff') format('woff'),
    url('../static/fonts/gotham-book.ttf') format('truetype'),
    url('../static/fonts/gotham-book.svg') format('svg');
  /* Legacy iOS */
}

.gotham-m {
  font-family: 'Gotham-Medium', Helvetica, Arial, sans-serif;
}

#app {
  font-family: 'Gotham-Book', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#langbtn {
  position: absolute;
  top: 16px;
  right: 16px;
}

.full-pic {
  display: flex;
  width: 80%;
  margin: 20px auto;
}

.guide-title {
  font-weight: bolder;
  text-align: left;
  margin-bottom: 2px;
  font-size: 36px;
}

.guide-desc {
  font-weight: 400;
  text-align: left;
  text-transform: uppercase;
}

.bg:before {
  content: ' ';
  position: fixed;
  z-index: -1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url('./images/background.jpg') center 0 no-repeat;
  background-size: cover;
}

.lbt-card {
  margin-bottom: 40px;
  border-radius: 10px;
}

.main-col .lbt-card + .lbt-card {
  background: white url('./images/background_block_top.jpg');
  background-size: 100% 5px;
  padding-top: 1px;
}

.lbt-card-title {
  color: #3f3f3f;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.5;
  text-transform: uppercase;
}

.subtitle {
  font-size: 16px;
}

.lbt-button {
  background-color: #01a58c;
  border-radius: 18px;
  color: #fff;
  width: 110px;
  height: 30px;
  text-transform: none !important;
}

.lbt-content-flex {
  color: #666;
  display: flex;
  align-items: center;
}

.lbt-content-flex > img {
  width: 40%;
  margin-right: 10px;
}

.lbt-content {
  color: #666;
  white-space: pre-wrap;
}

.lbt-content-light {
  color: #999;
  font-size: 13px;
  line-height: 1.4;
}

.lbt-content-dark {
  color: #333;
  font-weight: 800;
  margin-bottom: 8px;
}

.card-content {
  background-color: #fff;
  padding: 30px 25px;
  display: block;
  margin-top: 5px;
  border-top-left-radius: 3px !important;
  border-top-right-radius: 3px !important;
}

.spec-card {
  background-image: url('./images/background_spec.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.hairline {
  width: 100%;
  height: 5px;
  margin-bottom: 30px;
  border-bottom: 0.5px solid #e5e5e5;
}

.qr-pic {
  width: 35vw;
  height: 35vw;
  max-width: 250px;
  max-height: 250px;
  margin-bottom: 10px;
}

#menu > li {
  list-style: none;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  color: #666;
  cursor: pointer;
}

#menu > li:before {
  content: '';
  display: inline-block;
  margin-right: 15px;
  width: 16px;
  height: 16px;
  background-size: cover;
  background-image: url('./images/icon_navigation.png');
}
</style>



// WEBPACK FOOTER //
// src/App.vue